import { CONTROL_MARKERS_TO_WIN } from "../data/default-config";
import type { ControlAction } from "../types/actions";
import type { PlayerId } from "../types/common";
import type { WarchestState } from "../types/game-state";
import {
  advanceActivePlayer,
  allHandsEmpty,
  countControlledLocations,
  drawCoinsFromBag,
  getOpponent,
  moveCoin,
} from "../utils/zone-utils";

export function applyControl(
  state: WarchestState,
  action: ControlAction,
): WarchestState {
  const zones = moveCoin(
    state.playerZones[action.player],
    action.coinType,
    "hand",
    "discardFaceUp",
  );
  const prevLocation = state.locations[action.targetHex];
  const newLocations = {
    ...state.locations,
    [action.targetHex]: { controlledBy: action.player as PlayerId },
  };
  // If enemy previously controlled it, their marker returns (tracked via locations count)
  void prevLocation;

  let newPlayerZones = { ...state.playerZones, [action.player]: zones };
  const controlledCount = countControlledLocations(newLocations, action.player);
  const hasWon = controlledCount >= CONTROL_MARKERS_TO_WIN;

  if (hasWon) {
    return {
      ...state,
      locations: newLocations,
      playerZones: newPlayerZones,
      phase: "GAME_END",
      winner: action.player,
    };
  }

  // WARRIOR_PRIEST_DRAW: draw a coin from bag after controlling
  let rngState = state.rngState;
  if (
    state.config.units[action.coinType]?.attributeId === "WARRIOR_PRIEST_DRAW"
  ) {
    const { zones: drawnZones, rngState: newRng } = drawCoinsFromBag(
      newPlayerZones[action.player],
      1,
      rngState,
    );
    newPlayerZones = { ...newPlayerZones, [action.player]: drawnZones };
    rngState = newRng;
  }

  const nextActive = advanceActivePlayer(action.player, newPlayerZones);
  const nextPhase = allHandsEmpty(newPlayerZones)
    ? ("DRAW_COINS" as const)
    : state.phase;
  return {
    ...state,
    locations: newLocations,
    playerZones: newPlayerZones,
    activePlayer: nextActive,
    phase: nextPhase,
    rngState,
    initiativeTransferredThisRound:
      nextPhase === "DRAW_COINS" ? false : state.initiativeTransferredThisRound,
    turn: nextPhase === "DRAW_COINS" ? state.turn + 1 : state.turn,
  };
}

// Suppress unused import warning — getOpponent imported for potential use in game variants
void getOpponent;
